import React, { forwardRef } from 'react';
import { Box, Tooltip } from '@mui/material';

const LeftMenuItem = forwardRef(({ leftMenuItem, collapse, dragging, selectedMenuItem }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        position: 'relative',
        textDecoration: 'none',
        zIndex: '1000000000',
        borderColor: 'rgb(229, 229, 229)',
        borderBottomStyle: 'solid',
        borderBottomWidth: leftMenuItem.selected ? '1px' : '0px'
      }}
    >
      <div
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          cursor: 'pointer'
        }}
      >
        <a
          href={`${leftMenuItem.fieldPie2 ? '' : process.env.REACT_APP_FIELDPIE_OLD_URL}${leftMenuItem.path}`}
          style={{ cursor: 'pointer', textDecoration: 'none' }}
          draggable="false"
          onClick={(e) => {
            if (!dragging) {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
        >
          <Tooltip arrow={true} title={collapse && leftMenuItem.label} placement="top" style={{ float: 'left' }}>
            <Box
              className="menuItemLink"
              sx={{
                height: '55px',
                width: '255px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingLeft: '0px',
                backgroundColor: leftMenuItem.menuItemKey === selectedMenuItem ? 'rgba(236, 239, 241, 0.5)' : '#fff0'
              }}
            >
              <Box
                sx={{
                  ml: collapse ? 0.5 : 1.0,
                  mr: 2.5,
                  bgcolor: leftMenuItem.bgColor,
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img alt={leftMenuItem.label} src={`../../img/${leftMenuItem.image}`} style={{ marginLeft: leftMenuItem.path === '/tasks/' ? '3px' : '0' }} />
              </Box>
              <Box sx={{ fontSize: 14, color: leftMenuItem.menuItemKey === selectedMenuItem ? leftMenuItem.bgColor : '#455a64cc', fontWeight: '400' }}>
                {!collapse && leftMenuItem.label}
              </Box>
            </Box>
          </Tooltip>
        </a>
      </div>
    </div>
  );
});

LeftMenuItem.displayName = 'LeftMenuItem';

export default LeftMenuItem;
